import { DocumentsDataTableDocument } from 'generated/resources/datatable.graphql'
import {
  DocumentsDocument,
  MoveToTrashBinDocument,
  MoveToTrashBinMutation,
  MoveToTrashBinMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

const useMoveToTrashBinDocument = ({ fromDataTable = false }: { fromDataTable?: boolean }) => {
  const [moveDocumentToTrashBin, { loading }] = useMutation(MoveToTrashBinDocument, {
    extractorFn: (data: MoveToTrashBinMutation) =>
      data.documentsMutations.moveToTrashBinDocumentsDocument,
  })

  return {
    loading,
    moveDocumentToTrashBin(variables: MoveToTrashBinMutationVariables) {
      return moveDocumentToTrashBin({
        variables,
        awaitRefetchQueries: true,
        ...(fromDataTable
          ? {
              refetchQueries: [DocumentsDataTableDocument],
            }
          : {
              refetchQueries: [DocumentsDocument],
            }),
      })
    },
  }
}

export default useMoveToTrashBinDocument
